import { useNavigate, useParams } from "react-router-dom";
import { OnboardingPage } from "@/components/webbuilder/features/onboarding/OnboardingPage";

export default function WebBuilderOnboardingPage() {
  const navigate = useNavigate();
  const { storeType, storeId } = useParams<{ storeType: string; storeId: string }>();

  // Note: Removed pages fetching and redirect logic
  // The main middleware at /webbuilder handles routing based on pages
  // This page should only render when accessed directly or from import flow

  const handleCreatePage = () => {
    if (!storeType || !storeId) return;
    navigate(`/${storeType}/${storeId}/webbuilder/new-page`, {
      replace: true,
    });
  };

  const handleBrowseTemplates = () => {
    if (!storeType || !storeId) return;
    navigate(`/${storeType}/${storeId}/webbuilder/onboarding/templates`);
  };

  return (
    <OnboardingPage
      onCreatePage={handleCreatePage}
      onBrowseTemplates={handleBrowseTemplates}
    />
  );
}
